module.exports = __webpack_public_path__ + "img/modi-photograph.7fcd72b9.jpg";